import salesBudgetDailyInputLayout from './salesBudgetDailyInputLayout';

export default salesBudgetDailyInputLayout;
